/**
 * Maps TESTRELIC_RUN_TYPE to the cloud ingest enum so monitoring dashboards
 * (which filter by run_type) receive runs in the correct bucket.
 */
const ALLOWED = new Set(['smoke', 'regression', 'nightly', 'ci']);

export type SdkRunType = 'smoke' | 'regression' | 'nightly' | 'ci';

export function resolveSdkRunTypeFromEnv(): SdkRunType | undefined {
  const raw = process.env.TESTRELIC_RUN_TYPE?.trim().toLowerCase();
  if (!raw) return undefined;
  if (!ALLOWED.has(raw)) return undefined;
  return raw as SdkRunType;
}
